/**
 * Quem usa o fluxo Produtos V2 (listagem, criação e edição). Desde 23/09/2026 é o fluxo
 * oficial para toda conta, inclusive as que ainda vão nascer: a flag `products_v2` segue
 * gravada no banco mas não decide mais nada.
 *
 * Ligar por dado (conceder a flag a toda conta) exigiria repetir a concessão em cada
 * cadastro novo. O caminho de volta é reverter a mudança no código: uma flag de opt-out
 * não serve, porque o `ExperimentalFeature.save()` do backend concede toda feature nova
 * a todas as contas `@cakto.com.br`, e o time inteiro voltaria para o V1.
 */
export const hasProductsV2 = () => true;
